// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__36G4K","title":"AfterFrontImage_title__on2BB"};